import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { useLang, lp } from "@/lib/i18n";

const T = {
  fr: {
    seoTitle: "Page introuvable — Maison Partita", seoDesc: "La page demandée n'existe pas.",
    kicker: "Erreur", title: "Page introuvable", text: "Le lien demandé n'existe pas ou plus.",
    home: "La Maison",
  },
  en: {
    seoTitle: "Page not found — Maison Partita", seoDesc: "The requested page does not exist.",
    kicker: "Error", title: "Page not found", text: "The requested link does not exist, or no longer does.",
    home: "The House",
  },
};

export default function NotFound() {
  const lang = useLang();
  const t = T[lang];
  useSeo(t.seoTitle, t.seoDesc);
  return (
    <section className="max-w-xl mx-auto px-5 py-40 text-center" data-testid="not-found">
      <p className="text-[13px] tracking-[0.34em] uppercase text-zinc-500">{t.kicker}</p>
      <h1 className="mt-6 text-4xl sm:text-5xl tracking-[0.08em] text-zinc-50">{t.title}</h1>
      <p className="mt-8 text-zinc-400">{t.text}</p>
      <div className="mt-10 flex flex-wrap gap-5 justify-center">
        <Link to={lp(lang, "/")} className="val-btn" data-testid="notfound-home">{t.home}</Link>
        <Link to={lp(lang, "/dames")} className="val-btn" data-testid="notfound-dames">Dames</Link>
        <Link to={lp(lang, "/domino")} className="val-btn" data-testid="notfound-domino">Domino</Link>
      </div>
    </section>
  );
}
